/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios"
import { useContext, useEffect, useRef, useState } from "react";
import { Form, } from "react-bootstrap";
import Select from 'react-select';
import DashboardContext from "Context";

const InputSuggestion = ({ userId, groupId, addressId, startWork, NumberFemaleWorker, NumberMaleWorker, name, label, handelValue, disabled }) => {

    const { authentication, urldashboard, handelerrors } = useContext(DashboardContext);

    const selectInputRef = useRef();

    const [arrystate, setArrystate] = useState([])


    const deataFech = async () => {
        try {
            const res = await Axios.post(`${urldashboard}/worker/suggestion`, JSON.stringify({ userId, groupId, addressId, startWork, NumberFemaleWorker, NumberMaleWorker }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const data = await res.data.data
            setArrystate(data)
        } catch (error) {
            handelerrors(error)
        }
    }

    useEffect(() => {
        deataFech()
        return () => {

        }
    }, [userId, groupId, addressId, startWork, NumberFemaleWorker, NumberMaleWorker])


    const handeloncheng = (event) => {
        if (event) {
            handelValue(name, event.value)
        }
        else {
            handelValue(name, event)
        }

        if (disabled) {

        }
    }



    return (
        <Form.Group>
            {
                label ? <Form.Label>{label}</Form.Label>
                    : null
            }
            <Select
                className="basic-single"
                classNamePrefix="select"
                styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                onChange={handeloncheng}
                isLoading={arrystate?.length > 0 ? false : true}
                isRtl
                isClearable
                ref={selectInputRef}
                isDisabled={disabled}
                name={name}
                options={[{
                    label: label,
                    options: arrystate
                }]}
            />
        </Form.Group>
    );
}

export default InputSuggestion;
